/* eslint-disable react/react-in-jsx-scope */
import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import useText from "constants/text";
import { confirmCourseProps } from "domains/Course/data/types";
import { useConfirmModalStyle } from "domains/Course/style";

import Dialog from "ui/Dialog";

function ConfirmModal({ open, onConfirm, onClose, loading, isEdit }: confirmCourseProps) {
  const { text } = useText();
  const classes = useConfirmModalStyle();

  return (
    <div>
      <div>
        <Dialog
          open={open}
          confirmButtonTitle={text.all.confirm}
          cancelButtonTitle={text.all.cancel}
          handleClose={onClose}
          handleConfirm={onConfirm}
          maxWidth="xs"
          hideDialogHeader
          dialogActionButtonCustomized
          className={classes.dialog}
          fullWidth
          customStyle="width:330px; height: 400px"
        >
          <div className={classes.circle}>
            <Typography className={classes.helperIcon}>i</Typography>
          </div>
          <Grid container spacing={5}>
            <Grid item xs={12} className={classes.container}>
              <p className={classes.message}>{isEdit ? text.course.course_edition : text.course.course_creation}</p>
              <p className={classes.subMessage}>{text.course.course_creation_message}</p>
              <Button
                variant="contained"
                onClick={onConfirm}
                color="primary"
                className={classes.yesButton}
                size="large"
              >
                {text.all.yes_i_confirm} {loading && <CircularProgress className={classes.progressBar} size={15} />}
              </Button>
              <Button variant="contained" onClick={onClose} className={classes.cancelButton} size="large">
                {text.all.cancel}
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      </div>
    </div>
  );
}

export default ConfirmModal;
